import React from "react";
import CloseIcon from "src/components/icons/Close";

interface CloseBtnProps {
    onClick: () => void;
}
const CloseButton = ({ onClick }: CloseBtnProps) => {
    return (
        <span className={"locked-pricing-snackbar-close-btn"} onClick={onClick} aria-label="Close">
            <CloseIcon style={{ height: "14px", width: "14px" }} />
        </span>
    );
};
export default CloseButton;
